import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import { Col, Row, Button, Label, Input } from "reactstrap";
import axios from "axios";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";

function ArticulosMasterCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  const URL_LINEAS = process.env.REACT_APP_URL_LINEAS;
  const URL_MARCAS = process.env.REACT_APP_URL_MARCAS;
  const URL_FAMILIAS = process.env.REACT_APP_URL_FAMILIAS;
  const URL_UNIDADES_NEGOCIO = process.env.REACT_APP_URL_UNIDADES_NEGOCIO;
  const URL_PROVEEDORES = process.env.REACT_APP_URL_PROVEEDORES;

  const [nombre, setNombre] = useState("");
  const [SKU, setSKU] = useState("");
  const [MLM, setMLM] = useState("NA");
  const [medida, setMedida] = useState("NA");
  const [observaciones, setObservaciones] = useState("MASTER");

  const [lineas, setLineas] = useState([]);
  const [marcas, setMarcas] = useState([]);
  const [familias, setFamilias] = useState([]);
  const [unidadesNegocio, setUnidadesNegocio] = useState([]);
  const [proveedores, setProveedores] = useState([]);

  const [selectedLinea, setSelectedLinea] = useState("");
  const [selectedMarca, setSelectedMarca] = useState("");
  const [selectedFamilia, setSelectedFamilia] = useState("");
  const [selectedUnidadNegocio, setSelectedUnidadNegocio] = useState("");
  const [selectedProveedor, setSelectedProveedor] = useState("");

  const [validaBoton, setValidaBoton] = useState(true);
  // Si el usuario escribe el SKU a mano se deja de autogenerar
  const [skuManual, setSkuManual] = useState(false);

  // SKU del master: MAS + 3 letras del nombre + medida
  const generarSKU = (nombre, medida) => {
    const limpiar = (txt) =>
      (txt || "")
        .replace(/\s+/g, "")
        .replace(/[áàäâÁ]/g, "a")
        .replace(/[éèëêÉ]/g, "e")
        .replace(/[íìïîÍ]/g, "i")
        .replace(/[óòöôÓ]/g, "o")
        .replace(/[úùüûÚ]/g, "u")
        .toUpperCase();

    const nom = limpiar(nombre).substring(0, 3);
    const med = limpiar(medida);

    return `MAS${nom}${med}`;
  };

  useEffect(() => {
    if (skuManual) return;
    setSKU(generarSKU(nombre, medida));
  }, [nombre, medida, skuManual]);

  useEffect(() => {
    const h = { Authorization: `Bearer: ${localStorage.getItem("app_token")}` };
    axios.get(URL_LINEAS, { headers: h }).then((r) => setLineas(r.data || []));
    axios.get(URL_MARCAS, { headers: h }).then((r) => setMarcas(r.data || []));
    axios.get(URL_FAMILIAS, { headers: h }).then((r) => {
      setFamilias(r.data || []);
      if (r.data?.[0]) setSelectedFamilia(r.data[0]._id);
    });
    axios.get(URL_UNIDADES_NEGOCIO, { headers: h }).then((r) => {
      setUnidadesNegocio(r.data || []);
      if (r.data?.[0]) setSelectedUnidadNegocio(r.data[0]._id);
    });
    axios
      .get(`${URL_PROVEEDORES}Tipo/China`, { headers: h })
      .then((r) => {
        setProveedores(r.data || []);
        if (r.data?.[0]) setSelectedProveedor(r.data[0]._id);
      });
  }, []);

  const saveMaster = async (event) => {
    event.preventDefault();

    if (!nombre || !selectedLinea || !selectedMarca) {
      Swal.fire({
        icon: "error",
        title: "Faltan campos",
        text: "Nombre, Línea y Marca son obligatorios.",
      });
      return;
    }
    if (!selectedFamilia || !selectedUnidadNegocio || !selectedProveedor) {
      Swal.fire({
        icon: "error",
        title: "Catálogos vacíos",
        text: "No hay Familia / Unidad de Negocio / Proveedor disponible como default. Créalos en Catálogos primero.",
      });
      return;
    }

    setValidaBoton(false);

    try {
      // Sin sufijo: los 205 masters existentes usan el SKU tal cual y asi es como
      // se cruzan contra los SKU de los marketplaces
      const skuFinal = SKU || "NA";
      const articuloResp = await axios.post(
        URL_ARTICULOS,
        {
          // Los 205 masters existentes traen codigo === SKU === SKUBase
          codigo: skuFinal,
          codigoSAT: "NA",
          medida: medida || "NA",
          nombre,
          modelo: "MASTER",
          piezasPorCaja: 0,
          costoUSD: 0,
          costoCNY: 0,
          costoMX: 0,
          venta: 0,
          observaciones: observaciones || "MASTER",
          EAN: "NA",
          SKU: skuFinal,
          SKUBase: SKU || "NA",
          MLM: MLM || "NA",
          ASIN: "NA",
          ASINAntiguo: "NA",
          imagenes: "NA",
          linkML: "NA",
          linkShein: "NA",
          linkAmazon: "NA",
          linkCoppel: "NA",
          linkLiverpool: "NA",
          linkWalmart: "NA",
          linkElektra: "NA",
          cargadoML: "NA",
          cargadoShein: "NA",
          cargadoAmazon: "NA",
          cargadoCoppel: "NA",
          cargadoWalmart: "NA",
          cargadoLiverpool: "NA",
          cargadoElektra: "NA",
          largoProducto: 0,
          anchoProducto: 0,
          altoProducto: 0,
          pesoProducto: 0,
          largoEmpaque: 0,
          anchoEmpaque: 0,
          altoEmpaque: 0,
          pesoEmpaque: 0,
          largoMaster: 0,
          anchoMaster: 0,
          altoMaster: 0,
          pesoMaster: 0,
          stockMinimo: 0,
          stockMaximo: 0,
          indiceRotacion: 0,
          lineas: selectedLinea,
          marcas: selectedMarca,
          familias: selectedFamilia,
          unidadesNegocio: selectedUnidadNegocio,
          proveedores: selectedProveedor,
          especiales: "No",
          articuloPadre: null,
          lista1: 0,
          lista2: 0,
          lista3: 0,
          lista4: 0,
          lista1Bruto: 0,
          lista2Bruto: 0,
          lista3Bruto: 0,
          lista4Bruto: 0,
          comision: 0,
          otrosCostos: 0,
          ingresoPromedioNeto: 0,
          ingresoPromedioBruto: 0,
        },
        { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
      );

      await axios.post(
        URL_LOGS,
        {
          tipo: "Crear Master",
          detalle: `${nombre} ${skuFinal}`,
          user: user.id,
        },
        { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
      );

      Swal.fire(
        "Master creado",
        articuloResp.data && articuloResp.data.avisoVariante
          ? `${skuFinal}. ${articuloResp.data.avisoVariante}`
          : `${skuFinal} con su variante única (mismo SKU). Si maneja packs, dalos de alta como variantes.`,
        articuloResp.data && articuloResp.data.avisoVariante ? "warning" : "success"
      );
      setTimeout(() => (window.location.href = "/ListadoArticulosMaster"), 1000);
    } catch (error) {
      console.log(error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "No se pudo crear el master.",
        footer: `${
          error?.response?.data?.message ||
          error?.response?.data ||
          error.message ||
          ""
        }`,
      });
      setValidaBoton(true);
    }
  };

  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_articulos ? (
        <div className="card container col-8">
          <h3 align="center">Nuevo Artículo Master</h3>
          <p style={{ textAlign: "center", color: "#666" }}>
            Un master agrupa varias variantes. No maneja inventario directo: al crearlo se le crea su
            variante única (mismo SKU, 1 pieza), que es la que se recibe y se vende.
          </p>
          <br />
          <Row>
            <Col md={6}>
              <Label>Nombre *</Label>
              <Input
                type="text"
                placeholder="Nombre del producto master"
                value={nombre}
                required
                onChange={(e) => setNombre(e.target.value)}
              />
            </Col>
            <Col md={6}>
              <Label>SKU</Label>
              <Input
                type="text"
                placeholder="Se genera solo con Nombre + Medida"
                value={SKU}
                onChange={(e) => {
                  setSkuManual(true);
                  setSKU(e.target.value);
                }}
              />
              <small style={{ color: "#64748b", fontSize: "0.72rem" }}>
                {skuManual ? (
                  <>
                    Capturado a mano.{" "}
                    <a
                      href="#!"
                      onClick={(e) => {
                        e.preventDefault();
                        setSkuManual(false);
                      }}
                    >
                      Volver a generarlo automático
                    </a>
                  </>
                ) : (
                  "Automático: MAS + 3 letras del nombre + medida. Puedes sobreescribirlo."
                )}
              </small>
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={6}>
              <Label>MLM</Label>
              <Input
                type="text"
                placeholder="MLM"
                value={MLM}
                onChange={(e) => setMLM(e.target.value)}
              />
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={6}>
              <Label>Línea *</Label>
              <Input
                type="select"
                value={selectedLinea}
                required
                onChange={(e) => setSelectedLinea(e.target.value)}
              >
                <option value="">Selecciona línea</option>
                {lineas
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((l) => (
                    <option value={l._id} key={l._id}>
                      {l.name}
                    </option>
                  ))}
              </Input>
            </Col>
            <Col md={6}>
              <Label>Marca *</Label>
              <Input
                type="select"
                value={selectedMarca}
                required
                onChange={(e) => setSelectedMarca(e.target.value)}
              >
                <option value="">Selecciona marca</option>
                {marcas
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((m) => (
                    <option value={m._id} key={m._id}>
                      {m.name}
                    </option>
                  ))}
              </Input>
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={6}>
              <Label>Medida</Label>
              <Input
                type="text"
                placeholder="NA"
                value={medida}
                onChange={(e) => setMedida(e.target.value)}
              />
            </Col>
            <Col md={6}>
              <Label>Observaciones</Label>
              <Input
                type="text"
                value={observaciones}
                onChange={(e) => setObservaciones(e.target.value)}
              />
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={12}>
              <details>
                <summary style={{ cursor: "pointer" }}>
                  Defaults (auto) — Proveedor
                </summary>
                <div style={{ padding: "10px 0" }}>
                  <Row>
                    <Col md={4}>
                      <Label>Proveedor</Label>
                      <Input
                        type="select"
                        value={selectedProveedor}
                        onChange={(e) => setSelectedProveedor(e.target.value)}
                      >
                        {proveedores.map((p) => (
                          <option value={p._id} key={p._id}>
                            {p.nombre_comercial || p.razon_social || p._id}
                          </option>
                        ))}
                      </Input>
                    </Col>
                  </Row>
                </div>
              </details>
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={2}>
              {validaBoton ? (
                <Button type="submit" className="btn btn-success" onClick={saveMaster}>
                  Guardar
                </Button>
              ) : (
                <Button className="btn btn-success" disabled>
                  Guardando...
                </Button>
              )}
            </Col>
            <Col md={2}>
              <Button
                href="/ListadoArticulosMaster"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Col>
          </Row>
          <br />
        </div>
      ) : undefined}
    </>
  );
}

export default ArticulosMasterCreate;
